<template>
	<div id="showList" class="result-public-notice">
		<search-panel :searchdata="searchdata" :showBtn="showBtn" :tableCode="table_init.table_code" @passLimit="getLimit" :dirs="dirs"></search-panel>
		<base-table v-loading="loading" element-loading-text="加载中，请稍候" @passcurrentRow="(val)=>{currentRow=val[0].currentRow}" @sortChange="sortChange" @queryItem="queryItem" :dirs="dirs" :tableInit="table_init"></base-table>
		<pagination @paginationChange="paginationChange" :total="totalPage"></pagination>
	</div>
</template>
<script>
import { validateDateRange } from "@/tool/parse.js"
import { showList } from "@/assets/json.js"
import { Dictionaries, UnitCheck } from "@/resources.js"

import searchPanel from "@/components/common/search_panel_new.vue"
import baseTable from "@/components/common/base_table.vue"
import pagination from "@/components/common/pagination.vue"

export default {
	props: ['title'],
	data() {
		return {
			searchdata: searchdata,
			showBtn: showBtn,
			dirs: {
				"qualLevel": Dictionaries.qualLevel,
			},
			limit: {},
			table_init: showList.table_init,
			loading: false,
			totalPage: 0,
			page: 1,
			pageSize: 10,
			currentRow: {},
			sort: "noticeId",
			order: "asc",
		}
	},
	mounted() {
		this.queryAll();
	},
	methods: {
		getLimit(params) {
			switch (params[0]) {
				case "queryAll":
					{
						let t_limit = params[1];
						let limit = {};
						for (var i in t_limit) {
							if (typeof t_limit[i] == "object") {//el-datepicker返回的日期对象
								let dateStr = new Date(t_limit[i]);
								if (isNaN(dateStr.getDate())) { continue; }
								else {
									let year = dateStr.getFullYear();
									let month = dateStr.getMonth() + 1;
									let date = dateStr.getDate();
									limit[i] = year + "-" + (month >= 10 ? month : "0" + month) + "-" + (date >= 10 ? date : "0" + date);
								}
							}
							else if (t_limit[i] && t_limit[i].length > 0) {
								limit[i] = t_limit[i];
							}
						}
						this.limit = limit;
					}
					this.queryAll();
					break;
			}
		},
		sortChange(param) {
			if (param.order != null) {
				this.order = param.order.indexOf("asc") > -1 ? "asc" : "desc";
				this.sort = param.prop;
				this.queryAll();
			}
		},
		paginationChange(param) {
			this.pageSize = param[0];
			this.page = param[1];
			this.queryAll();
		},
		queryAll() {
			if (!validateDateRange(this.limit.startActive, this.limit.endActive, this, "发出时间起始日期 应小于 截止日期")) { return; }
			if (!validateDateRange(this.limit.startOnlie, this.limit.endOnlie, this, "生效时间起始日期 应小于 截止日期")) { return; }
			this.table_init.body = [];
			this.loading = true;
			let limit = {};
			for (let i in this.limit) { limit[i] = this.limit[i]; }
			limit[this.sort + "_order"] = this.order;
			//需要新接口 4个
			if (this.title == '公示期的记分告知单') {
				// UnitCheck.resultPublic("publicList", "/" + this.pageSize + "/" + this.page, { limit: limit }).then(res => {
				// 	this.table_init.body = res.data;
				// 	this.totalPage = res.total;
				// 	this.loading = false;
				// })
			}
			else if (this.title == '已生效的记分告知单') {
				// UnitCheck.resultPublic("publicList", "/" + this.pageSize + "/" + this.page, { limit: limit }).then(res => {
				// 	this.table_init.body = res.data;
				// 	this.totalPage = res.total;
				// 	this.loading = false;
				// })
			}
			else if (this.title == '公示期的合同履约评价单') {
				// UnitCheck.resultPublic("publicList", "/" + this.pageSize + "/" + this.page, { limit: limit }).then(res => {
				// 	this.table_init.body = res.data;
				// 	this.totalPage = res.total;
				// 	this.loading = false;
				// })
			}
			else if (this.title == '已生效的合同履约评价单') {
				// UnitCheck.resultPublic("publicList", "/" + this.pageSize + "/" + this.page, { limit: limit }).then(res => {
				// 	this.table_init.body = res.data;
				// 	this.totalPage = res.total;
				// 	this.loading = false;
				// })
			}
		},
		queryItem(row) {
			this.currentRow = row;
		},
	},
	components: { searchPanel, baseTable, pagination }
}
var showBtn = [
	{ "label": "查询", attr: "queryAll" },
];
var searchdata = [
	{ name: "工程项目名称", attr: "proName", type: "text", isRange: false, "dictionary": "" },
	{ name: "记分主体", attr: "scoreMain", type: "text", isRange: false, "dictionary": "" },
	{ name: "发出时间", attr: "activeDate", type: "date", isRange: true, "dictionary": "", children: { startAttr: "startActive", endAttr: "endActive" } },
	{ name: "生效时间", attr: "onlineDatetime", type: "date", isRange: true, "dictionary": "", children: { startAttr: "startOnlie", endAttr: "endOnlie" } },
];

</script>


// WEBPACK FOOTER //
// inforList.vue?7f284b2f